import React from "react";
import Radios from "@radarly/components/panels/card-edition/sidebar/radios";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { useSecondaryUnit } from "./model";

export interface SecondaryUnitProps {
  dataviz: DatavizHorizontalBarChart;
  setDataviz: (dataviz: DatavizHorizontalBarChart) => void;
}

export default function SecondaryUnit({
  dataviz,
  setDataviz,
}: SecondaryUnitProps) {
  const { label, options, option, onChange, isDisabled } = useSecondaryUnit(
    dataviz,
    setDataviz
  );
  return (
    <Radios
      label={label}
      value={option.value}
      options={options}
      onChange={onChange}
      disabled={isDisabled}
    />
  );
}
